import React from 'react'
import CustomDataGrid from './components/CustomDataGrid'

const PendingEmailList: React.FC = () => {
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ width: '100%', position: 'relative' }}>
        <CustomDataGrid />
      </div>
    </div>
  )
}

export default PendingEmailList
